import * as z from 'zod'
import { generateErrorMessage } from 'zod-error'
import 'zod-openapi/extend'

type ZodError = z.ZodError

// biome-ignore lint/suspicious/noExplicitAny: <using any here is allowed, since z.infer will provided a type.>
type ZodInfer<T extends z.ZodType<any, any>> = z.infer<T>

export { generateErrorMessage, z, type ZodError, type ZodInfer }
